import {
    CContainer,
    CRow,
    CCol,
    CButton,
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CModalFooter,
    CFormTextarea,
} from "@coreui/react";
import { cilPlus } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import React, { useEffect, useContext, useState, useCallback } from "react";
import { CustomBreadcrumbs, FaqsTable } from "../../components";
import { AppContext } from "../../context/AppContext";

const Faqs = () => {
    const { getFaqs, addFaq, deleteFaq, editFaq } = useContext(AppContext);

    const [faqs, setFaqs] = useState([]);
    const [faqsPagination, setFaqsPagination] = useState({});
    const [faqsPage, setFaqsPage] = useState(1);
    const [addData, setAddData] = useState({
        question: "",
        answer: "",
    });
    const [selectedFaq, setselectedFaq] = useState(false);
    const [addModalVisible, setAddModalVisible] = useState(false);
    const [deleteModalVisible, setDeleteModalVisible] = useState(false);
    const [editModalVisible, setEditModalVisible] = useState(false);
    const [editData, setEditData] = useState({
        question: "",
        answer: "",
    });
    
    const handleFaqSelected = (id, type) => {
        const faq = faqs.find((faq) => faq.id === id);
        setselectedFaq(faq);
        if (type === "edit") {
            setEditData({
                question: faq.question,
                answer: faq.answer,
            });
            setEditModalVisible(true);
        }
        if( type === "delete"){
            setDeleteModalVisible(true);
        }
    };

    const handleAddDataChange = (key, value) => {
        setAddData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleAdd = () => {
        addFaq(addData);
        setAddModalVisible(false);
        setFaqsPage(1);
        fetchFAQs(1);
        setAddData({
            question: "",
            answer: "",
        });
    };

    const goToFirstPageAndRefetch = () => {
            setFaqsPage(1);
            fetchFAQs(1);
        };

    const handleDelete = () => {
        deleteFaq(selectedFaq.id);
        setDeleteModalVisible(false);
        goToFirstPageAndRefetch(1);
    };

    const handleEditDataChange = (key, value) => {
        setEditData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleSave = () => {
        editFaq(selectedFaq.id, editData);
        setEditModalVisible(false);
        goToFirstPageAndRefetch(1);
    };

    const faqsColumns = [
        {
            key: "question",
            label: "Pregunta",
            _props: { scope: "col", className: "w-25" },
        },
        {
            key: "answer",
            label: "Respuesta",
            _props: { scope: "col", className: "w-60" },
        },
        {
            key: "actions",
            label: "Acciones",
            _props: { scope: "col", className: "w-15" },
        },
    ];

    // This function can be called manually or inside the useEffect
    const fetchFAQs = useCallback(async (page) => {
        const faqResponse = await getFaqs(page);
        setFaqs(faqResponse.data.data);
        setFaqsPagination(faqResponse.data.meta);
    }, []);

    // Run effect when `faqsPage` changes
    useEffect(() => {
        fetchFAQs(faqsPage);
    }, [faqsPage, fetchFAQs]);

    return (
        <div>
            <CustomBreadcrumbs
                parentTitle={"Configuración"}
                activeTitle="Preguntas frecuentes"
            />
            <CContainer>
                <CRow className="justify-content-between">
                    <CCol xs="auto">
                        <h2 className="title mb-0">Preguntas Frecuentes</h2>
                    </CCol>
                    <CCol xs="auto" className="ms-auto">
                        <CButton
                            color="primary"
                            size="lg"
                            style={{
                                backgroundColor: "#E2AA01",
                                border: "0",
                            }}
                            onClick={() => {
                                setAddModalVisible(true);
                            }}
                        >
                            <CIcon icon={cilPlus} /> Añadir Pregunta
                        </CButton>
                    </CCol>
                </CRow>
                <CRow className="mt-4">
                    {!!faqs.length ? (
                        <FaqsTable
                            columns={faqsColumns}
                            data={faqs}
                            pagination={faqsPagination}
                            setFaqsPage={setFaqsPage}
                            handleFaqSelected={handleFaqSelected}
                        />
                    ) : (
                        <CRow className="justify-content-between mt-4">
                            <CCol xs={12}>
                                <h4>
                                    Todavía no ha cargado ninguna Pregunta
                                    Frecuente, presione el botón "Agregar" para
                                    comenzar a cargar.
                                </h4>
                            </CCol>
                        </CRow>
                    )}
                </CRow>
            </CContainer>
            {/* Add Modal */}
            <CModal
                visible={addModalVisible}
                onClose={() => setAddModalVisible(false)}
            >
                <CModalHeader>
                    <CModalTitle>Agregar Pregunta</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    {/* Example editable fields using rowData */}
                    <div className="mb-3">
                        <label>Pregunta</label>
                        <CFormTextarea
                            rows="2"
                            value={addData.question}
                            onChange={(e) =>
                                handleAddDataChange("question", e.target.value)
                            }
                        />
                    </div>
                    <div className="mb-3">
                        <label>Respuesta</label>
                        <CFormTextarea
                            rows="6"
                            defaultValue={addData.answer}
                            onChange={(e) =>
                                handleAddDataChange("answer", e.target.value)
                            }
                        />
                    </div>
                </CModalBody>
                <CModalFooter>
                    <CButton
                        color="secondary"
                        onClick={() => setAddModalVisible(false)}
                    >
                        Close
                    </CButton>
                    <CButton color="primary" onClick={handleAdd}>
                        Guardar Cambios
                    </CButton>
                </CModalFooter>
            </CModal>
            {/* Delete Confirmation Modal */}
            <CModal
                visible={deleteModalVisible}
                onClose={() => setDeleteModalVisible(false)}
            >
                <CModalHeader>
                    <CModalTitle>Confirm Delete</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    Está seguro que deseas borrar la pregunta "
                    {selectedFaq?.question}"?
                </CModalBody>
                <CModalFooter>
                    <CButton
                        color="secondary"
                        onClick={() => setDeleteModalVisible(false)}
                    >
                        Cancel
                    </CButton>
                    <CButton color="danger" onClick={handleDelete}>
                        Delete
                    </CButton>
                </CModalFooter>
            </CModal>
            {/* Edit Modal */}
            <CModal
                visible={editModalVisible}
                onClose={() => setEditModalVisible(false)}
            >
                <CModalHeader>
                    <CModalTitle>Editar Pregunta</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    {/* Example editable fields using rowData */}
                    <div className="mb-3">
                        <label>Pregunta</label>
                        <CFormTextarea
                            rows="2"
                            value={editData.question}
                            onChange={(e) =>
                                handleEditDataChange("question", e.target.value)
                            }
                        />
                    </div>
                    <div className="mb-3">
                        <label>Respuesta</label>
                        <CFormTextarea
                            rows="6"
                            defaultValue={editData.answer}
                            onChange={(e) =>
                                handleEditDataChange("answer", e.target.value)
                            }
                        />
                    </div>
                </CModalBody>
                <CModalFooter>
                    <CButton
                        color="secondary"
                        onClick={() => setEditModalVisible(false)}
                    >
                        Close
                    </CButton>
                    <CButton color="primary" onClick={handleSave}>
                        Guardar Cambios
                    </CButton>
                </CModalFooter>
            </CModal>
        </div>
    );
};

export default Faqs;
